import HeroSection from "../components/HeroSection";
import ResearchSection from "../components/ResearchSection";
import ExperienceSection from "../components/ExperienceSection";
import SkillsSection from "../components/SkillsSection";
import AwardsSection from "../components/AwardSection";
import AboutSection from "../components/AboutSection";

export default function HomePage() {
  return (
    <>
      <HeroSection />
      <AboutSection />
      <SkillsSection />
      <ExperienceSection />
      <ResearchSection />
      <AwardsSection />
    </>
  );
}
